import Swiper from "swiper";
import { Autoplay } from 'swiper/modules';

export const SwiperMarquee = () => {
	const elements = document.querySelectorAll('.swiper-marquee');
	elements.forEach((el) => {
		const wrapper = el.querySelector('.swiper-wrapper');
		if (!wrapper) {
			console.warn('[SwiperMarquee] skipping init: .swiper-wrapper not found', el);
			return;
		}

		new Swiper(el, {
			modules: [Autoplay],
			loop: true,
			slidesPerView: 'auto',
			freeMode: true,
			freeModeLinear: true,
			freeModeMomentum: false,
			freeModeSticky: false,
			speed: 5000,
			spaceBetween: 48,
			allowTouchMove: false,
			simulateTouch: false,
			mousewheel: false,
			autoplay: {
				delay: 0,
				disableOnInteraction: false,
			},
			breakpoints: {
				320: {
					slidesPerView: 2,
				},
				640: {
					slidesPerView: 3,
				},
				1024: {
					slidesPerView: 4,
				},
				1440: {
					slidesPerView: 5,
				},
				1920: {
					slidesPerView: 6,
				},
			},
		});
	});
};
